import React from "react"
import Layout from "../components/layout";
import AnalysePage from "../components/analyses/AnalysePage";

export default function AnalyseTemplate({
                                         pageContext: { content } }) {
     const {title} = content
    return  <Layout title={`${title}`}><AnalysePage jsonAnalyse={content}
    /></Layout>
}